/**
 * Kopieren der Adresse des Feeds (UC-019 Schritt 2, docs/ux-design.md 5.7) und der API-Anleitung bzw. des API-Tokens
 * (UC-023 Schritt 4, A3): über die Zwischenablage, sonst wird der Text im Feld markiert, damit er sich von Hand kopieren
 * lässt (UC-023 A4).
 */
import { BESTAETIGUNG_MS, type Geraet } from './teilen';

export async function kopieren(text: string, geraet: Pick<Geraet, 'clipboard'>): Promise<boolean> {
  if (typeof geraet.clipboard?.writeText !== 'function') {
    return false;
  }
  try {
    await geraet.clipboard.writeText(text);
    return true;
  } catch {
    // Zugriff verweigert, z. B. ohne HTTPS
    return false;
  }
}

/**
 * Richtet den Knopf «Kopieren» in einem Bereich mit data-kopieren ein. Zeigt das Feld einen verdeckten Text, steht der
 * vollständige in data-voll; er wird kopiert bzw. vor dem Markieren aufgedeckt. data-kopiert am Knopf ersetzt die
 * Bestätigung «Adresse kopiert».
 */
export function kopierenEinrichten(bereich: HTMLElement, geraet: Pick<Geraet, 'clipboard'> = navigator): void {
  const feld = bereich.querySelector<HTMLInputElement | HTMLTextAreaElement>('[data-kopieren-text]');
  const knopf = bereich.querySelector<HTMLButtonElement>('[data-kopieren-knopf]');
  const bestaetigung = bereich.querySelector<HTMLOutputElement>('[data-kopieren-bestaetigung]');
  if (!feld || !knopf || !bestaetigung) {
    return;
  }
  const text = feld.dataset.voll ?? feld.value;
  const kopiert = knopf.dataset.kopiert ?? 'Adresse kopiert';
  let ausblenden: ReturnType<typeof setTimeout> | undefined;

  knopf.addEventListener('click', async () => {
    if (await kopieren(text, geraet)) {
      bestaetigung.textContent = kopiert;
      clearTimeout(ausblenden);
      ausblenden = setTimeout(() => {
        bestaetigung.textContent = '';
      }, BESTAETIGUNG_MS);
    } else {
      feld.value = text;
      feld.focus();
      feld.select();
    }
  });
}
